import { render, staticRenderFns } from "./mirbuilder.vue?vue&type=template&id=40e0fe29&"
import script from "./mirbuilder.vue?vue&type=script&lang=ts&"
export * from "./mirbuilder.vue?vue&type=script&lang=ts&"
import style0 from "./mirbuilder.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports